export default __webpack_public_path__ + "static/media/dozule5.2123e341.jpg";